import "./style.scss";

const SkeletonText = ({ onlyOne }: { onlyOne?: boolean }) => {
    return (
        <div className="text-wrapper-skeleton">
            {!onlyOne && (
                <>
                    <div className="text skeleton"></div>
                    <div className="text skeleton"></div>
                    <div className="text skeleton"></div>
                </>
            )}
            <div className="text skeleton"></div>
        </div>
    );
};

export default SkeletonText;
